import { css } from '@emotion/css';

export const inputStyles = css`
  background: none;
  min-height: 0;
  border-radius: 0;
  textarea {
    padding-top: 0;
    padding-bottom: 0;
    background: none;
  }
  *::selection {
    color: black;
    background: #e4e7eb;
  }
`;
